/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const entitlementDataSchema = z.object({
	entitlements: z.array(
		z.union([
			z.literal('jobilla-meet'),
			z.literal('fully-serviced'),
			z.literal('addon-ats-integration'),
			z.literal('addon-custom-templates'),
			z.literal('addon-custom-invoicing-config'),
			z.literal('addon-whatsapp'),
		]),
	),
	enforced: z.boolean(),
	subscriptionAccess: z.object({
		hasAccess: z.boolean(),
		reason: z.union([
			z.literal('subscribed'),
			z.literal('parent-subscribed'),
			z.literal('demo'),
			z.literal('external-invoicing'),
			z.literal('fully-serviced'),
			z.literal('exempt'),
			z.literal('jobilla-staff'),
			z.literal('subscription-inactive'),
			z.literal('no-subscription'),
		]),
		endsAt: z.iso.datetime().nullable(),
		pastDue: z.boolean().default(false),
		trialEndsAt: z.iso.datetime().nullable(),
	}),
	canSendToReview: z.boolean().default(false),
	isFullyServiced: z.boolean().default(false),
	entitlementsSyncedAt: z.iso.datetime().nullable(),
	campaignUsage: z.number().nullable(),
	campaignLimit: z.number().nullable(),
	campaignPeriodStart: z.string().nullable(),
	campaignPeriodEnd: z.string().nullable(),
})

export type EntitlementDataSchema = z.infer<typeof entitlementDataSchema>
